<template>
    <div>
        <div
            v-if="!deleteDisabled">
            <button
                v-if="!useAnchorTag"
                @click="handleBtnClick"
                type="button"
                :class="btnClass"
                class="inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-red-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:border-red-700 focus:ring-red transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            >
                {{ value }}
            </button>

            <a
                v-if="useAnchorTag"
                @click="handleBtnClick"
                :class="btnClass"
            >
                {{ value }}
            </a>

            <delete-modal
                :active="isModalOpen"
                :delete-route="deleteRoute"
                :delete-options="deleteOptions"
                @close="isModalOpen = false"
            ></delete-modal>
        </div>

        <div
            v-if="deleteDisabled"
        >
            <button
                v-if="!useAnchorTag"
                type="button"
                :class="btnClass"
                class="inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-red-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:border-red-700 focus:ring-red transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                style="filter: opacity(25%);"
                v-tooltip="{ content: deleteTooltip || '', container: false, placement: 'bottom', html: false, }"
            >
                {{ value }}
            </button>

            <a
                v-if="useAnchorTag"
                :class="btnClass"
                style="filter: opacity(25%);"
                v-tooltip="{ content: deleteTooltip || '', container: false, placement: 'bottom', html: false, }"
            >
                {{ value }}
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: "delete-button",
    props: {
        btnClass: String,
        value: {
            type: String,
            required: true,
        },
        deleteRoute: {
            type: String,
            required: true,
        },
        deleteOptions: {
            type: Object,
            required: false,
        },
        deleteDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        deleteTooltip: {
            type: String,
            required: false
        },
        useAnchorTag: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            isModalOpen: false,
        };
    },
    methods: {
        handleBtnClick: function () {
            this.isModalOpen = true;
        },
    },
};
</script>
